module.exports = __webpack_public_path__ + "images/img-3FMsbe2.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/ru/6.png
// module id = 2355
// module chunks = 0